/**
 * Schedule model translations
 *
 * Translation keys follow the pattern: models.schedule.{category}.{key}
 * Categories: fields, tabs, blocks, badges, actions, filters
 */
export default {
  en: {
    // Model names
    singular: "Schedule",
    plural: "Schedules",

    // Tabs
    tabs: {
      details: "Schedule Details",
      assignment_details: "Assignment Details",
      app_data: "Custom Data",
    },

    // Blocks
    blocks: {
      schedulable: "Task Details",
      assignment: "Assignment",
      status: "Status",
      team: "Team Information",
      metadata: "Metadata",
      custom_data: "App-Specific Data",
      task_selection: "Task Selection",
      options: "Options",
    },

    // Fields
    fields: {
      display_title: "Task Title",
      display_description: "Description",
      display_duration: "Duration",
      schedulable_type: "Task Type",
      assigned_to: {
        name: "Employee",
      },
      assigned_to_user_id: "Employee ID",
      employee: "Employee",
      employee_id: "Employee ID",
      scheduled_date: "Scheduled Date",
      priority: "Priority",
      status: "Status",
      completed_at: "Completed At",
      team_type: "Team Type",
      alternance: "Shift",
      metadata: "Metadata",
      app_data: "App Data",
      task: "Task",
      schedulable_selector: "Select Task",
    },

    // Badges (status values)
    badges: {
      pending: "Pending",
      in_progress: "In Progress",
      completed: "Completed",
      canceled: "Canceled",
    },

    // Select options
    options: {
      alternance: {
        none: "None",
        a: "Shift A",
        b: "Shift B",
      },
    },

    // Actions
    actions: {
      week_view: "Week View",
    },

    // Filters
    filters: {
      status: "Status",
      assigned_to_user_id: "Employee",
      scheduled_date: "Date",
    },

    // Help text
    help: {
      assigned_to_user_id: "UUID of the employee to assign",
      metadata: "Custom schedule metadata (steps, overrides, etc.)",
      app_data: "App-specific extensible data",
      schedulable_selector: "Select a task to schedule (PartyTask, internal Task, etc.)",
    },
  },

  fr: {
    // Model names
    singular: "Horaire",
    plural: "Horaires",

    // Tabs
    tabs: {
      details: "Détails de l'horaire",
      assignment_details: "Détails d'affectation",
      app_data: "Données personnalisées",
    },

    // Blocks
    blocks: {
      schedulable: "Détails de la tâche",
      assignment: "Affectation",
      status: "Statut",
      team: "Informations d'équipe",
      metadata: "Métadonnées",
      custom_data: "Données spécifiques à l'application",
      task_selection: "Sélection de tâche",
      options: "Options",
    },

    // Fields
    fields: {
      display_title: "Titre de la tâche",
      display_description: "Description",
      display_duration: "Durée",
      schedulable_type: "Type de tâche",
      assigned_to: {
        name: "Employé",
      },
      assigned_to_user_id: "ID d'employé",
      employee: "Employé",
      employee_id: "ID d'employé",
      scheduled_date: "Date prévue",
      priority: "Priorité",
      status: "Statut",
      completed_at: "Complété le",
      team_type: "Type d'équipe",
      alternance: "Quart",
      metadata: "Métadonnées",
      app_data: "Données d'application",
      task: "Tâche",
      schedulable_selector: "Sélectionner une tâche",
    },

    // Badges (status values)
    badges: {
      pending: "En attente",
      in_progress: "En cours",
      completed: "Complété",
      canceled: "Annulé",
    },

    // Select options
    options: {
      alternance: {
        none: "Aucun",
        a: "Quart A",
        b: "Quart B",
      },
    },

    // Actions
    actions: {
      week_view: "Vue hebdomadaire",
    },

    // Filters
    filters: {
      status: "Statut",
      assigned_to_user_id: "Employé",
      scheduled_date: "Date",
    },

    // Help text
    help: {
      assigned_to_user_id: "UUID de l'employé à affecter",
      metadata: "Métadonnées d'horaire personnalisées (étapes, remplacements, etc.)",
      app_data: "Données extensibles spécifiques à l'application",
      schedulable_selector: "Sélectionnez une tâche à planifier (PartyTask, tâche interne, etc.)",
    },
  },
};
